import React from "react";
import { Route } from "react-router-dom";
import { AUTH_LEVELS } from "../lib/globals";
import NotFound from "../components/NotFound";
import RequireAuth from "../components/RequireAuth";
import MySchedule, {
    loader as MyScheduleLoader,
} from "../pages/MySchedule/Schedule";
import CoachReview, {
    loader as CoachReviewLoader,
} from "../pages/MySchedule/CoachReview";
import EjectionReport, {
    loader as EjectionReportLoader,
} from "../pages/MySchedule/EjectionReport";

export default (
    <Route element={<RequireAuth allowedUserLevels={AUTH_LEVELS.all} />}>
        <Route path="my-schedule" handle={{ crumb: () => "My Schedule" }}>
            <Route
                path="current"
                element={<MySchedule />}
                loader={params =>
                    MyScheduleLoader({
                        ...params,
                        schedule: "current",
                    })
                }
                handle={{
                    crumb: () => "Upcoming Schedule",
                    header: () => "Upcoming Schedule",
                }}
            />
            <Route
                path="past"
                element={<MySchedule />}
                loader={params =>
                    MyScheduleLoader({
                        ...params,
                        schedule: "past",
                    })
                }
                handle={{
                    crumb: () => "Past Schedule",
                    header: () => "Past Schedule",
                }}
            />
            <Route path=":gameId">
                <Route
                    path="coach-review"
                    element={<CoachReview />}
                    loader={CoachReviewLoader}
                    handle={{
                        crumb: () => "Coach Review",
                        header: () => "Coach Review",
                    }}
                />
                <Route
                    path="ejection-report"
                    element={<EjectionReport />}
                    loader={EjectionReportLoader}
                    handle={{
                        crumb: () => "Ejection Report",
                        header: () => "Ejection Report",
                    }}
                />
            </Route>
        </Route>
        <Route path="*" element={<NotFound parent="myschedule" />} />
    </Route>
);
